import { AppType } from './appType'

export interface AppTheme {
  primary: string // hex, e.g. #ff1647
  primaryHover: string // hex – darker shade for hover states
  primaryRgb: string // R, G, B triplet for rgba() usage, e.g. "255, 22, 71"
}

export const APP_THEMES: Record<AppType, AppTheme> = {
  sushi: {
    primary: '#ff1647',
    primaryHover: '#cc1138',
    primaryRgb: '255, 22, 71',
  },
  catering: {
    primary: '#16a34a',
    primaryHover: '#15803d',
    primaryRgb: '22, 163, 74',
  },
}

export function applyAppTheme(appType: AppType): void {
  const theme = APP_THEMES[appType]
  const root = document.documentElement
  root.style.setProperty('--color-primary', theme.primary)
  root.style.setProperty('--color-primary-hover', theme.primaryHover)
  root.style.setProperty('--color-primary-rgb', theme.primaryRgb)
}
